import React from "react";
import { useTranslation } from "react-i18next";
import { Body2, Caption1 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import i18n from "~/i18n";

const legendData = [
  { color: "tw-bg-red-alert", text: i18n.t("Low or Critical") },
  { color: "tw-bg-[var(--warning)]", text: i18n.t("Medium") },
  { color: "tw-bg-[var(--color-sucess-green)]", text: i18n.t("High") },
];

export const UtilizationLegend = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames("tw-flex tw-items-center tw-gap-6", className)}>
      <div className="tw-flex tw-items-center tw-gap-1">
        <Body2
          weight="bold"
          color="alert"
        >
          OFF
        </Body2>
        <Caption1
          color="tertiary"
          italic
        >
          - {t("Member is not available")}
        </Caption1>
      </div>
      {legendData.map(({ color, text }) => (
        <div
          key={text}
          className="tw-flex tw-items-center tw-gap-1"
        >
          <div className={`${color} tw-rounded tw-w-4 tw-h-4`} />
          <Caption1
            color="tertiary"
            italic
          >
            - {text}
          </Caption1>
        </div>
      ))}
    </div>
  );
};

UtilizationLegend.propTypes = {
  className: PropTypes.string,
};
